import React, { FunctionComponent } from 'react';
import { TaskFormTrigger } from '../../../dialogs/TaskFormDialog/TaskFormTrigger';
import { TaskDragDropContext } from '../../common/drag-drop-contexts/TaskDragDropContext';
import { authSelectors } from '../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../app/resource/user/user.selectors';
import { meetingSimpleSelectors } from '../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { IMeetingSimple } from '../../../../app/resource/meeting-simple/meeting-simple.types';
import { isMemberPartOfMeeting } from '../../../../utils/user.utils';
import { Goals } from './Goals';

import { IGoalsBoardProps } from './types';
import { useSelect, useSelectWithParams } from '../../../../utils/selector.utils';

export const GoalsBoard: FunctionComponent<IGoalsBoardProps> = ({ userIds, goals, adminIds, meetingId }) => {
  const loggedUserId = useSelect(authSelectors.selectLoggedUser);
  const loggedUser = useSelectWithParams(userSelectors.selectResourceById, loggedUserId ?? '');

  const meeting = (useSelectWithParams(
    meetingSimpleSelectors.selectResourceById,
    meetingId ?? '',
  ) as unknown) as IMeetingSimple;

  const isMeetingMember = loggedUser && meeting && isMemberPartOfMeeting(loggedUser, meeting);

  return (
    <div className="row mb-25 mt-3">
      <div className="col-12">
        <div className="panel vto-text">
          <div style={{ zIndex: 0 }} className="panel-header small-header no-border pb-0">
            <h2 className="bold">Goals</h2>
            {isMeetingMember && (
              <div className="ml-auto flex aic">
                <TaskFormTrigger meetingId={meetingId} />
              </div>
            )}
          </div>
          <div className="cards-container-overflow">
            <TaskDragDropContext>
              <div className="cards-container">
                {userIds.map((userId) => (
                  <Goals userId={userId} key={userId} goals={goals} adminIds={adminIds} meetingId={meetingId ?? ''} />
                ))}
              </div>
            </TaskDragDropContext>
          </div>
        </div>
      </div>
    </div>
  );
};
